import React from 'react';
import { MonthTuple, mountInterval } from '@src/common/calendar';
import { Grid, Slot, Square, type MonthThumbSize } from '@src/domains/scheduling/components/MonthThumb/styles';

export type MonthThumbProps = {
  monthTuple: MonthTuple;
  size?: MonthThumbSize;
};

const MonthThumb = ({ monthTuple, size = 'comfortable' }: MonthThumbProps) => {
  const [, month] = monthTuple;
  return (
    <Grid size={size} aria-hidden='true'>
      {mountInterval(monthTuple).map((interval) =>
        interval.month === month ? (
          <Square key={interval.dateString} size={size} />
        ) : (
          <Slot key={interval.dateString} size={size} />
        ),
      )}
    </Grid>
  );
};

export default MonthThumb;
